import AxiosLiveStream from './axios_live_stream_api'

const ModuleLiveStream = {
  state: {
    stateGenTokenStream: [],
    stateLiveListProduct: [],
    stateUpdatePinProduct: [],
    stateGetPinProduct: [],
    stateUpdateProductCartLive: [],
    stateGetProductCartLive: [],
    stateAddComment: [],
    stateGetComments: [],
    stateGenerateLiveShopURL: [],
    stateUpdateOverlayImg: [],
    stateUpdatePositionOverlay: [],
    stateGetOverlayImg: [],
    stateGetOverlayDetail: [],
    stateCheckLiveStatus: [],
    stateGetShopLive: [],
    stateDeleteRoom: [],
    stateGetProfileImage: [],
    stateSendHeart: [],
    stateGetHeartCount: [],
    stateAddParticipant: [],
    stateGetParticipant: [],
    stateRemoveOverLayImage: [],
    stateGetToken: [],
    stateGetAllRoomV2: [],
    stateGetTokenLive: [],
    stateGetStatusLive: [],
    stateUpdateStatusLive: [],
    stateDataSelectedCartLive: [],
    stateGetTokenBuyer: [],
    stateDeleteRoomBuyer: [],
    stateUpdatePinProductBuyer: [],
    stateUpdateProductCartLiveBuyer: [],
    stateGetProductCartLiveBuyer: [],
    stateDataSelectedCartLiveBuyer: [],
    stateGenerateLiveAffiliate: [],
    stateGetAffiliateID: [],
    stateUpdatePinCoupon: [],
    stateGetPinCoupon: [],
    stateUpdateCouponsLive: [],
    stateGetSelectedCouponsLive: [],
    stateUpdateCouponsLiveBuyer: [],
    stateUpdatePinCouponBuyer: [],
    stateGetPinCouponBuyer: [],
    stateGetShopIdCoupon: [],
    stateGetShopLiveDetail: [],
    stateGetDataEndLive: [],
    stateIncrementLiveShareCount: [],
    statePinComment: [],
    stateGetPinnedComment: [],
    stateCreateDealLive: [],
    stateListDealLive: [],
    stateExpireDealLive: [],
    stateListMissionCoupon: [],
    stateCheckMissionCoupon: [],
    stateCheckCoupon: [],
    stateExportLiveHistoryExcel: [],
    statecheckQuestion: [],
    stateGetShopLiveKit: [],
    stateGetDataLiveStatus: [],
    stateGetDataLiveDailySummary: [],
    stateGetDataLiveTrend: [],
    stateStartLive: [],
    stateViewSessionExportPDF: [],
    stateGetMissionList: [],
    stateEditMissionLive: [],
    stateGetListCouponOptionstMissionLive: [],
    stateInsertCouponCouponOptionstMissionLive: [],
    stateUpdateCouponInMissionLive: [],
    stateNotificationPushLive: [],
    stateGetMissionTimer: []
  },
  mutations: {
    mutationsGenTokenStream (state, data) {
      state.stateGenTokenStream = data
    },
    mutationsLiveListProduct (state, data) {
      state.stateLiveListProduct = data
    },
    mutationsUpdatePinProduct (state, data) {
      state.stateUpdatePinProduct = data
    },
    mutationsGetPinProduct (state, data) {
      state.stateGetPinProduct = data
    },
    mutationsUpdateProductCartLive (state, data) {
      state.stateUpdateProductCartLive = data
    },
    mutationsGetProductCartLive (state, data) {
      state.stateGetProductCartLive = data
    },
    mutationsAddComment (state, data) {
      state.stateAddComment = data
    },
    mutationsGetComments (state, data) {
      state.stateGetComments = data
    },
    mutationsGenerateLiveShopURL (state, data) {
      state.stateGenerateLiveShopURL = data
    },
    mutationsUpdateOverlayImg (state, data) {
      state.stateUpdateOverlayImg = data
    },
    mutationsUpdatePositionOverlay (state, data) {
      state.stateUpdatePositionOverlay = data
    },
    mutationsGetOverlayImg (state, data) {
      state.stateGetOverlayImg = data
    },
    mutationsGetOverlayDetail (state, data) {
      state.stateGetOverlayDetail = data
    },
    mutationsCheckLiveStatus (state, data) {
      state.stateCheckLiveStatus = data
    },
    mutationsGetShopLive (state, data) {
      state.stateGetShopLive = data
    },
    mutationsDeleteRoom (state, data) {
      state.stateDeleteRoom = data
    },
    mutationSendHeart (state, data) {
      state.stateSendHeart = data
    },
    mutationGetProfileImage (state, data) {
      state.stateGetProfileImage = data
    },
    mutationGetHeartCount (state, data) {
      state.stateGetHeartCount = data
    },
    mutationAddParticipant (state, data) {
      state.stateAddParticipant = data
    },
    mutationGetParticipant (state, data) {
      state.stateGetParticipant = data
    },
    mutationRemoveOverLayImage (state, data) {
      state.stateRemoveOverLayImage = data
    },
    mutationGetToken (state, data) {
      state.stateGetToken = data
    },
    mutationGetAllRoomV2 (state, data) {
      state.stateGetAllRoomV2 = data
    },
    mutationGetTokenLive (state, data) {
      state.stateGetTokenLive = data
    },
    mutationsGetStatusLive (state, data) {
      state.stateGetStatusLive = data
    },
    mutationsUpdateStatusLive (state, data) {
      state.stateUpdateStatusLive = data
    },
    mutationsDataSelectedCartLive (state, data) {
      state.stateDataSelectedCartLive = data
    },
    mutationsGetTokenBuyer (state, data) {
      state.stateGetTokenBuyer = data
    },
    mutationsDeleteRoomBuyer (state, data) {
      state.stateDeleteRoomBuyer = data
    },
    mutationsUpdatePinProductBuyer (state, data) {
      state.stateUpdatePinProductBuyer = data
    },
    mutationsUpdateProductCartLiveBuyer (state, data) {
      state.stateUpdateProductCartLiveBuyer = data
    },
    mutationsGetProductCartLiveBuyer (state, data) {
      state.stateGetProductCartLiveBuyer = data
    },
    mutationsDataSelectedCartLiveBuyer (state, data) {
      state.stateDataSelectedCartLiveBuyer = data
    },
    mutationsGenerateLiveAffiliate (state, data) {
      state.stateGenerateLiveAffiliate = data
    },
    mutationsGetAffiliateID (state, data) {
      state.stateGetAffiliateID = data
    },
    mutationsUpdatePinCoupon (state, data) {
      state.stateUpdatePinCoupon = data
    },
    mutationsGetPinCoupon (state, data) {
      state.stateGetPinCoupon = data
    },
    mutationsUpdateCouponsLive (state, data) {
      state.stateUpdateCouponsLive = data
    },
    mutationsGetSelectedCouponsLive (state, data) {
      state.stateGetSelectedCouponsLive = data
    },
    mutationsUpdateCouponsLiveBuyer (state, data) {
      state.stateUpdateCouponsLiveBuyer = data
    },
    mutationsUpdatePinCouponBuyer (state, data) {
      state.stateUpdatePinCouponBuyer = data
    },
    mutationsGetPinCouponBuyer (state, data) {
      state.stateGetPinCouponBuyer = data
    },
    mutationsGetShopIdCoupon (state, data) {
      state.stateGetShopIdCoupon = data
    },
    mutationsGetShopLiveDetail (state, data) {
      state.stateGetShopLiveDetail = data
    },
    mutationsGetDataEndLive (state, data) {
      state.stateGetDataEndLive = data
    },
    mutationsIncrementLiveShareCount (state, data) {
      state.stateIncrementLiveShareCount = data
    },
    mutationsPinComment (state, data) {
      state.statePinComment = data
    },
    mutationsGetPinnedComment (state, data) {
      state.stateGetPinnedComment = data
    },
    mutationsCreateDealLive (state, data) {
      state.stateCreateDealLive = data
    },
    mutationsListDealLive (state, data) {
      state.stateListDealLive = data
    },
    mutationsExpireDealLive (state, data) {
      state.stateExpireDealLive = data
    },
    mutationsListMissionCoupon (state, data) {
      state.stateListMissionCoupon = data
    },
    mutationsCheckMissionCoupon (state, data) {
      state.stateCheckMissionCoupon = data
    },
    mutationsCheckCoupon (state, data) {
      state.stateCheckCoupon = data
    },
    mutationsStartLive (state, data) {
      state.stateStartLive = data
    },
    mutationsExportLiveHistoryExcel (state, data) {
      state.stateExportLiveHistoryExcel = data
    },
    mutationscheckQuestion (state, data) {
      state.statecheckQuestion = data
    },
    mutationsGetShopLiveKit (state, data) {
      state.stateGetShopLiveKit = data
    },
    mutationsGetDataLiveStatus (state, data) {
      state.stateGetDataLiveStatus = data
    },
    mutationsGetDataLiveDailySummary (state, data) {
      state.stateGetDataLiveDailySummary = data
    },
    mutationsGetDataLiveTrend (state, data) {
      state.stateGetDataLiveTrend = data
    },
    mutationsViewSessionExportPDF (state, data) {
      state.stateViewSessionExportPDF = data
    },
    mutationsGetMissionList (state, data) {
      state.stateGetMissionList = data
    },
    mutationsInsertMissionLive (state, data) {
      state.stateInsertMissionLive = data
    },
    mutationsEditMissionLive (state, data) {
      state.stateEditMissionLive = data
    },
    mutationsGetListCouponOptionstMissionLive (state, data) {
      state.stateGetListCouponOptionstMissionLive = data
    },
    mutationsInsertCouponCouponOptionstMissionLive (state, data) {
      state.stateInsertCouponCouponOptionstMissionLive = data
    },
    mutationsUpdateCouponInMissionLive (state, data) {
      state.stateUpdateCouponInMissionLive = data
    },
    mutationsNotificationPushLive (state, data) {
      state.stateNotificationPushLive = data
    },
    mutationsGetMissionTimer (state, data) {
      state.stateGetMissionTimer = data
    }
  },
  actions: {
    // Gen Live Stream
    async actionsGenTokenStream (context, access) {
      const responseData = await AxiosLiveStream.GenTokenStream(access)
      await context.commit('mutationsGenTokenStream', responseData)
    },
    async actionsLiveListProduct (context, access) {
      const responseData = await AxiosLiveStream.LiveListProduct(access)
      await context.commit('mutationsLiveListProduct', responseData)
    },
    async actionsUpdatePinProduct (context, access) {
      const responseData = await AxiosLiveStream.UpdatePinProduct(access)
      await context.commit('mutationsUpdatePinProduct', responseData)
    },
    async actionsGetPinProduct (context, access) {
      const responseData = await AxiosLiveStream.GetPinProduct(access)
      await context.commit('mutationsGetPinProduct', responseData)
    },
    async actionsUpdateProductCartLive (context, access) {
      const responseData = await AxiosLiveStream.UpdateProductCartLive(access)
      await context.commit('mutationsUpdateProductCartLive', responseData)
    },
    async actionsGetProductCartLive (context, access) {
      const responseData = await AxiosLiveStream.GetProductCartLive(access)
      await context.commit('mutationsGetProductCartLive', responseData)
    },
    async actionsAddComment (context, access) {
      const responseData = await AxiosLiveStream.AddComment(access)
      await context.commit('mutationsAddComment', responseData)
    },
    async actionsGetComments (context, access) {
      const responseData = await AxiosLiveStream.GetComments(access)
      await context.commit('mutationsGetComments', responseData)
    },
    async actionsGenerateLiveShopURL (context, access) {
      const responseData = await AxiosLiveStream.GenerateLiveShopURL(access)
      await context.commit('mutationsGenerateLiveShopURL', responseData)
    },
    async actionsUpdateOverlayImg (context, access) {
      const responseData = await AxiosLiveStream.UpdateOverlayImg(access)
      await context.commit('mutationsUpdateOverlayImg', responseData)
    },
    async actionsUpdatePositionOverlay (context, access) {
      const responseData = await AxiosLiveStream.UpdatePositionOverlay(access)
      await context.commit('mutationsUpdatePositionOverlay', responseData)
    },
    async actionsGetOverlayImg (context, access) {
      const responseData = await AxiosLiveStream.GetOverlayImg(access)
      await context.commit('mutationsGetOverlayImg', responseData)
    },
    async actionsGetOverlayDetail (context, access) {
      const responseData = await AxiosLiveStream.GetOverlayDetail(access)
      await context.commit('mutationsGetOverlayDetail', responseData)
    },
    async actionsCheckLiveStatus (context, access) {
      const responseData = await AxiosLiveStream.CheckLiveStatus(access)
      await context.commit('mutationsCheckLiveStatus', responseData)
    },
    async actionsGetShopLive (context, access) {
      const responseData = await AxiosLiveStream.GetShopLive(access)
      await context.commit('mutationsGetShopLive', responseData)
    },
    async actionsDeleteRoom (context, access) {
      const responseData = await AxiosLiveStream.deleteRoom(access)
      await context.commit('mutationsDeleteRoom', responseData)
    },
    async actionsGetProfileImage (context, access) {
      const responseData = await AxiosLiveStream.GetProfileImage(access)
      await context.commit('mutationGetProfileImage', responseData)
    },
    async actionsSendHeart (context, access) {
      const responseData = await AxiosLiveStream.SendHeart(access)
      await context.commit('mutationSendHeart', responseData)
    },
    async actionsGetHeartCount (context, access) {
      const responseData = await AxiosLiveStream.GetHeartCount(access)
      await context.commit('mutationGetHeartCount', responseData)
    },
    async actionsAddParticipant (context, access) {
      const responseData = await AxiosLiveStream.AddParticipant(access)
      await context.commit('mutationAddParticipant', responseData)
    },
    async actionsGetParticipant (context, access) {
      const responseData = await AxiosLiveStream.GetParticipant(access)
      await context.commit('mutationGetParticipant', responseData)
    },
    async actionsRemoveOverLayImage (context, access) {
      const responseData = await AxiosLiveStream.RemoveOverLayImage(access)
      await context.commit('mutationRemoveOverLayImage', responseData)
    },
    async actionsGetToken (context, access) {
      const responseData = await AxiosLiveStream.GetToken(access)
      await context.commit('mutationGetToken', responseData)
    },
    async actionsGetAllRoomV2 (context, access) {
      const responseData = await AxiosLiveStream.GetAllRoomV2(access)
      await context.commit('mutationGetAllRoomV2', responseData)
    },
    async actionsGetTokenLive (context, access) {
      const responseData = await AxiosLiveStream.GetTokenLive(access)
      await context.commit('mutationGetTokenLive', responseData)
    },
    async actionsGetStatusLive (context, access) {
      var response = await AxiosLiveStream.GetStatusLive(access)
      await context.commit('mutationsGetStatusLive', response)
    },
    async actionsUpdateStatusLive (context, access) {
      var response = await AxiosLiveStream.UpdateStatusLive(access)
      await context.commit('mutationsUpdateStatusLive', response)
    },
    async actionsDataSelectedCartLive (context, access) {
      var response = await AxiosLiveStream.DataSelectedCartLive(access)
      await context.commit('mutationsDataSelectedCartLive', response)
    },
    async actionsGetTokenBuyer (context, access) {
      var response = await AxiosLiveStream.GetTokenBuyer(access)
      await context.commit('mutationsGetTokenBuyer', response)
    },
    async actionsDeleteRoomBuyer (context, access) {
      var response = await AxiosLiveStream.deleteRoomBuyer(access)
      await context.commit('mutationsDeleteRoomBuyer', response)
    },
    async actionsUpdatePinProductBuyer (context, access) {
      var response = await AxiosLiveStream.UpdatePinProductBuyer(access)
      await context.commit('mutationsUpdatePinProductBuyer', response)
    },
    async actionsUpdateProductCartLiveBuyer (context, access) {
      var response = await AxiosLiveStream.UpdateProductCartLiveBuyer(access)
      await context.commit('mutationsUpdateProductCartLiveBuyer', response)
    },
    async actionsDataSelectedCartLiveBuyer (context, access) {
      var response = await AxiosLiveStream.DataSelectedCartLiveBuyer(access)
      await context.commit('mutationsDataSelectedCartLiveBuyer', response)
    },
    async actionsGenerateLiveAffiliate (context, access) {
      var response = await AxiosLiveStream.GenerateLiveAffiliate(access)
      await context.commit('mutationsGenerateLiveAffiliate', response)
    },
    async actionsGetAffiliateID (context, access) {
      var response = await AxiosLiveStream.GetAffiliateID(access)
      await context.commit('mutationsGetAffiliateID', response)
    },
    async actionsUpdatePinCoupon (context, access) {
      var response = await AxiosLiveStream.UpdatePinCoupon(access)
      await context.commit('mutationsUpdatePinCoupon', response)
    },
    async actionsGetPinCoupon (context, access) {
      var response = await AxiosLiveStream.GetPinCoupon(access)
      await context.commit('mutationsGetPinCoupon', response)
    },
    async actionsUpdateCouponsLive (context, access) {
      var response = await AxiosLiveStream.UpdateCouponsLive(access)
      await context.commit('mutationsUpdateCouponsLive', response)
    },
    async actionsGetSelectedCouponsLive (context, access) {
      var response = await AxiosLiveStream.GetSelectedCouponsLive(access)
      await context.commit('mutationsGetSelectedCouponsLive', response)
    },
    async actionsUpdateCouponsLiveBuyer (context, access) {
      var response = await AxiosLiveStream.UpdateCouponsLiveBuyer(access)
      await context.commit('mutationsUpdateCouponsLiveBuyer', response)
    },
    async actionsUpdatePinCouponBuyer (context, access) {
      var response = await AxiosLiveStream.UpdatePinCouponBuyer(access)
      await context.commit('mutationsUpdatePinCouponBuyer', response)
    },
    async actionsGetPinCouponBuyer (context, access) {
      var response = await AxiosLiveStream.GetPinCouponBuyer(access)
      await context.commit('mutationsGetPinCouponBuyer', response)
    },
    async actionsGetShopIdCoupon (context, access) {
      var response = await AxiosLiveStream.GetShopIdCoupon(access)
      await context.commit('mutationsGetShopIdCoupon', response)
    },
    async actionsGetShopLiveDetail (context, access) {
      var response = await AxiosLiveStream.GetShopLiveDetail(access)
      await context.commit('mutationsGetShopLiveDetail', response)
    },
    async actionsGetDataEndLive (context, access) {
      var response = await AxiosLiveStream.GetDataEndLive(access)
      await context.commit('mutationsGetDataEndLive', response)
    },
    async actionsIncrementLiveShareCount (context, access) {
      var response = await AxiosLiveStream.IncrementLiveShareCount(access)
      await context.commit('mutationsIncrementLiveShareCount', response)
    },
    async actionsPinComment (context, access) {
      var response = await AxiosLiveStream.PinComment(access)
      await context.commit('mutationsPinComment', response)
    },
    async actionsGetPinnedComment (context, access) {
      var response = await AxiosLiveStream.GetPinnedComment(access)
      await context.commit('mutationsGetPinnedComment', response)
    },
    async actionsCreateDealLive (context, access) {
      var response = await AxiosLiveStream.CreateDealLive(access)
      await context.commit('mutationsCreateDealLive', response)
    },
    async actionsListDealLive (context, access) {
      var response = await AxiosLiveStream.ListDealLive(access)
      await context.commit('mutationsListDealLive', response)
    },
    async actionsExpireDealLive (context, access) {
      var response = await AxiosLiveStream.ExpireDealLive(access)
      await context.commit('mutationsExpireDealLive', response)
    },
    async actionsListMissionCoupon (context, access) {
      var response = await AxiosLiveStream.ListMissionCoupon(access)
      await context.commit('mutationsListMissionCoupon', response)
    },
    async actionsRefreshTokenLive (context, access) {
      await AxiosLiveStream.RefreshToken(access)
    },
    async actionsCheckMissionCoupon (context, access) {
      var response = await AxiosLiveStream.CheckMissionCoupon(access)
      await context.commit('mutationsCheckMissionCoupon', response)
    },
    async actionsCheckCoupon (context, access) {
      var response = await AxiosLiveStream.CheckCoupon(access)
      await context.commit('mutationsCheckCoupon', response)
    },
    async actionsStartLive (context, access) {
      var response = await AxiosLiveStream.StartLive(access)
      await context.commit('mutationsStartLive', response)
    },
    async actionsExportLiveHistoryExcel (context, access) {
      var response = await AxiosLiveStream.ExportLiveHistoryExcel(access)
      await context.commit('mutationsExportLiveHistoryExcel', response)
    },
    async actionscheckQuestion (context, access) {
      var response = await AxiosLiveStream.checkQuestion(access)
      await context.commit('mutationscheckQuestion', response)
    },
    async actionsGetShopLiveKit (context, access) {
      var response = await AxiosLiveStream.GetShopLiveKit(access)
      await context.commit('mutationsGetShopLiveKit', response)
    },
    async actionsGetDataLiveStatus (context, access) {
      var response = await AxiosLiveStream.GetDataLiveStatus(access)
      await context.commit('mutationsGetDataLiveStatus', response)
    },
    async actionsGetDataLiveDailySummary (context, access) {
      var response = await AxiosLiveStream.GetDataLiveDailySummary(access)
      await context.commit('mutationsGetDataLiveDailySummary', response)
    },
    async actionsGetDataLiveTrend (context, access) {
      var response = await AxiosLiveStream.GetDataLiveTrend(access)
      await context.commit('mutationsGetDataLiveTrend', response)
    },
    async actionsViewSessionExportPDF (context, access) {
      var response = await AxiosLiveStream.ViewSessionExportPDF(access)
      await context.commit('mutationsViewSessionExportPDF', response)
    },
    async actionsGetMissionList (context, access) {
      var response = await AxiosLiveStream.GetMissionList(access)
      await context.commit('mutationsGetMissionList', response)
    },
    async actionsInsertMissionLive (context, access) {
      var response = await AxiosLiveStream.InsertMissionLive(access)
      await context.commit('mutationsInsertMissionLive', response)
    },
    async actionsEditMissionLive (context, access) {
      var response = await AxiosLiveStream.EditMissionLive(access)
      await context.commit('mutationsEditMissionLive', response)
    },
    async actionsGetListCouponOptionstMissionLive (context, access) {
      var response = await AxiosLiveStream.GetListCouponOptionstMissionLive(access)
      await context.commit('mutationsGetListCouponOptionstMissionLive', response)
    },
    async actionsInsertCouponCouponOptionstMissionLive (context, access) {
      var response = await AxiosLiveStream.InsertCouponCouponOptionstMissionLive(access)
      await context.commit('mutationsInsertCouponCouponOptionstMissionLive', response)
    },
    async actionsUpdateCouponInMissionLive (context, access) {
      var response = await AxiosLiveStream.UpdateCouponInMissionLive(access)
      await context.commit('mutationsUpdateCouponInMissionLive', response)
    },
    async actionsNotificationPushLive (context, access) {
      var response = await AxiosLiveStream.NotificationPushLive(access)
      await context.commit('mutationsNotificationPushLive', response)
    },
    async actionsGetMissionTimer (context, access) {
      var response = await AxiosLiveStream.GetMissionTimer(access)
      await context.commit('mutationsGetMissionTimer', response)
    }
  }
}
export default ModuleLiveStream
